module.exports = __webpack_public_path__ + "img/7.a2200bd6.jpg";